import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import MainApiService from "../../../../../services/mainApi.service";
import { ISendLimitsMonth } from "../../../../../models/send-limit-month";
import { Chip } from "@mui/material";

const SEND_LIMIT_MONTH_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/SendLimitMonth/";
const sendLimitMonthService = new MainApiService<ISendLimitsMonth>(
  SEND_LIMIT_MONTH_ROUTE
);

const translationPath = "page.settings.crm.sendLimitMonths.";

const SendLimitMonthsPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { eI } = useParams();

  const columns: GridColDef<ISendLimitsMonth>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "valueLimit",
      headerName: t(translationPath + "quantity") || "Diary Limit",
      renderCell: (params) => {
        if (!params.value) return "-";
        return params.value.name;
      },
    },
    {
      field: "startDate",
      headerName: t(translationPath + "start_date") || "Start Date",
      renderCell: ({ row: { startDate } }) => {
        if (startDate && startDate.length > 0) {
          const date = new Date(startDate);
          return (
            <OverflowTooltip
              text={date.toLocaleDateString("pt-BR")}
              tooltip={date.toLocaleDateString("pt-BR")}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
    {
      field: "endDate",
      headerName: t(translationPath + "end_date") || "End Date",
      renderCell: ({ row: { endDate } }) => {
        if (endDate && endDate.length > 0) {
          const date = new Date(endDate);
          return (
            <OverflowTooltip
              text={date.toLocaleDateString("pt-BR")}
              tooltip={date.toLocaleDateString("pt-BR")}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
    {
      field: "enable",
      headerName: t(translationPath + "active") || "Enable",
      maxWidth: 150,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={
              params.value
                ? t(translationPath + "enabled")
                : t(translationPath + "disabled")
            }
            color={params.value ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<ISendLimitsMonth>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<ISendLimitsMonth>
      showDefaultMacroFilters={false}
      service={sendLimitMonthService}
      columns={columns}
      title={t(translationPath + "send_limits_months")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      backButton
      backButtonUrl={`/e/${eI}/dashboard/settings`}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={
        t(translationPath + "add_send_limit_months") ||
        "Add monthly trigger limit"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default SendLimitMonthsPage;
